export default __webpack_public_path__ + "static/media/Location Map.5e7c4a14.png";